<template>
  <div id="page-container" class="sidebar-dark enable-page-overlay side-scroll page-header-fixed">
    <Aside></Aside>
      <Sidebar></Sidebar>
      <page-header></page-header>
      <main id="main-container">
        <div class="content content-narrow">
          <router-view/>
        </div>
      </main>
    <Footer></Footer>
    <HeaderPopup></HeaderPopup>
    <AddReminder></AddReminder>
    <Feedback></Feedback>
  </div>
</template>
<script>
import Aside from '@/components/Aside';
import Sidebar from '@/components/Sidebar';
import PageHeader from '@/components/PageHeader';
import Footer from '@/components/Footer';
import HeaderPopup from '@/modals/HeaderPopup';
import AddReminder from '@/components/modals/AddReminder';
import Feedback from '@/components/modals/Feedback';

export default {
  name: 'Layout',
  data() {
    return {
    };
  },
  components: {
    Aside,
    Sidebar,
    PageHeader,
    Footer,
    HeaderPopup,
    AddReminder,
    Feedback
  }
};
</script>

<style>
#main-container {
  min-height: calc(100vh - 61px);
}
.table-overlay .block-options {
  padding-left: 0;
}
#page-container {
  min-width: 100% !important;
}
.action {
  padding-top: 15px;
  padding-bottom: 15px;
}
.text-break {
  width: 17%;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// source/components/Layout.vue